import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import { LoadingButton } from "@mui/lab";

import { FormInput } from "components/FormInput";

import { ReactComponent as CloseIcon } from "assets/images/icon_delete_input.svg";

import { PaymentTypeResponse } from "api";
import { actionCreators as paymentTypeActions } from "store/PaymentType";
import { actionCreators as orderActions } from "store/Order";

// import analytics from "services/analytics";
// import { AnalyticsEvents } from "shared/constants/analytics";

interface ReduxProps {
  getPaymentTypeList: () => void;
  setNonCashPaymentType: (paymentType: PaymentTypeResponse | null) => void;
  createPaymentType: (
    name: string,
    onSuccess?: (paymentType?: PaymentTypeResponse) => void,
    onError?: () => void
  ) => void;
}

interface Props {
  isOpenModal: boolean;
  onCloseModal: () => void;
}

type FormValues = {
  name: string;
};

const PaymentTypeDialog: FC<Props & ReduxProps> = (props) => {
  const [isLoading, setLoading] = useState(false);
  const { isOpenModal, onCloseModal } = props;

  const methods = useForm<FormValues>({
    mode: "onChange",
  });

  const name = methods.watch("name");

  const onSubmit = (data: FormValues) => {
    const { createPaymentType, getPaymentTypeList, setNonCashPaymentType } =
      props;
    setLoading(true);
    // analytics().sendEvent(AnalyticsEvents.sales_create_receipt);
    createPaymentType(
      data.name,
      async (paymentType?: PaymentTypeResponse) => {
        await getPaymentTypeList();
        paymentType && setNonCashPaymentType(paymentType);
        setLoading(false);
        onCloseModal();
      },
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <Dialog
      fullWidth
      open={isOpenModal}
      PaperProps={{ sx: { minHeight: 420, maxWidth: 424 } }}
    >
      <DialogTitle>
        <Box>
          <Typography variant="h3">Додати новий засіб оплати</Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onCloseModal}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <FormProvider {...methods}>
          <Box>
            <Typography mb={0.5} variant="body2">
              Назва засобу оплати:
            </Typography>
            <FormInput fullWidth name="name" autoFocus={true} />
          </Box>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          sx={{ margin: "16px" }}
          fullWidth
          size="large"
          onClick={methods.handleSubmit(onSubmit)}
          loading={isLoading}
          disabled={!name}
        >
          Зберегти
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  createPaymentType: paymentTypeActions.createPaymentType,
  getPaymentTypeList: paymentTypeActions.getPaymentTypeList,
  setNonCashPaymentType: orderActions.setNonCashPaymentType,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTypeDialog);
